import React from "react";
import styles from "./styles/IndustrialSolutionsHero.module.css";
import heroBg from "../../../images/InfraBG.jpg";

export default function IndustrialSolutionsHero() {
  return (
    <section className={styles.hero} style={{ backgroundImage: `url(${heroBg})` }}>
      <div className={styles.overlay} aria-hidden="true" />
      <div className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.title}>Industrial Solutions</h1>
          <p className={styles.description}>Committed to help building a better infrastructure</p>
        </div>
      </div>
    </section>
  );
}
